<template>
  <div class="card">
    <div class="card-header"><h5>Order Receipt</h5></div>
    <div class="card-body">
      <div>
        This receipt represents the state of your order at time of payment.  Fees charged by our payment processor are not included.
        Please print a copy of this receipt for your records.
      </div>
      <div class="card">
        <div class="card-header">Order Information</div>
        <div class="card-body">
          <b-row>
            <b-col>
              <span class="font-weight-bold">Order Number</span>
              <div>{{order.orderNumber}}</div>
            </b-col>
            <b-col>
              <span class="font-weight-bold">Date Submitted</span>
              <div>{{order.orderDate}}</div>
            </b-col>
            <b-col>
              <span class="font-weight-bold">Status</span>
              <div>{{order.status?.description}}</div>
            </b-col>
            <b-col>
              <span class="font-weight-bold">Payment Status</span>
              <div>{{order?.payment?.status}}</div>
            </b-col>
          </b-row>
          <b-row v-if="order.status?.code === 'PAY'" class="mt-2">
            <b-col>
              Please note that payment status will not update until US Bank has processed your payment.
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="card">
        <div class="card-header">Products</div>
        <div class="card-body">
          <b-row>
            <b-col>
              <b-row>
                <b-col class="font-weight-bold">Product Line Item</b-col>
                <b-col class="font-weight-bold">Record Subject Name</b-col>
                <b-col class="font-weight-bold">Quantity Ordered</b-col>
                <b-col class="font-weight-bold">Product Fee</b-col>
              </b-row>
              <b-card-group v-for="(orderProduct, index) in order.orderProducts" :key="index">
                <b-card row-justify="center">
                  <b-row>
                    <b-col>
                      {{orderProduct.product?.name}}
                    </b-col>
                    <b-col>
                      {{orderProduct.subjectNameOrYear}}
                    </b-col>
                    <b-col>
                      {{orderProduct.quantity}}
                    </b-col>
                    <b-col>
                      ${{orderProduct.fee?.amount}}
                    </b-col>
                  </b-row>
                </b-card>
              </b-card-group>
              <b-card-group >
                <b-card>
                  <b-row>
                    <b-col offset="8">
                      <span class="font-weight-bold">Product Total:</span> ${{totalProductFee(order)}}
                    </b-col>
                  </b-row>
                  <b-row v-for="(fee, index) in order.nonProductFees" :key="index">
                    <b-col offset="8">
                      <span class="font-weight-bold">{{fee.feeType.description}} Fee:</span> ${{fee.amount}}
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col offset="8">
                      <span class="font-weight-bold">Total: ${{totalFee(order)}}</span>
                    </b-col>
                  </b-row>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <OrderReviewReadonly :order="order" :profile="profile" :attachments="attachments"/>
      <b-row>
        <b-col offset="10">
          <b-button type="button" variant="primary" @click="print" class="no-print">
            Print
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>


import axiosRetry from 'axios-retry'
import axios from "axios"
import LocalStorageService from "@/common/LocalStorageService";
import OrderReviewReadonly from "@/components/checkout-wizard/OrderReviewReadonly.vue";
import {totalService} from "@/mixins/totalService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

const localStorageService = LocalStorageService.getService();


export default {
  components: {
    OrderReviewReadonly
  },
  data: () => {
    return {
      order: {},
      profile: {},
      attachments: [],
      orderNumber: null,
    }
  },
  mixins: [
    totalService
  ],
  created() {
    this.orderNumber = this.$route.params.orderNumber
  },
  mounted() {
    this.loadOrder()
    this.loadProfile()
    this.loadCurrentAttachments()
  },
  methods: {
    loadOrder() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/order/receipt/${this.orderNumber}`)
          .then(response => {
            this.order = response.data
          })
    },
    loadProfile(id){
      if (this.$keycloak.authenticated) {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile`)
            .then(response=>{
              if (response.data != null) {
                this.profile = response.data
              }
            })
      } else {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/profile/receipt/${this.orderNumber}`)
            .then(response=>{
              if (response.data != null) {
                this.profile = response.data
              }
            })
      }
    },
    loadCurrentAttachments(id) {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/receipt/${this.orderNumber}`)
          .then(response => {
            this.attachments = response.data
          })
    },
    print(){
      window.print();
    }
  }
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
